/** German strings merged into translations.de (see translations.js). */
export const deSupplement = {
  header: {
    home: "Startseite",
    product: "Produkt",
    industries: "Branchen",
    offers: "Angebote",
    see_all_products: "Alle Produkte ansehen",
  },
  footer_extra: {
    contact_us: "Kontakt",
    offices: "Neuchâtel · Manchester · Freiburg",
    subscribed: "Angemeldet.",
    could_not_subscribe: "Anmeldung fehlgeschlagen. Bitte erneut versuchen.",
    rights: "Alle Rechte vorbehalten.",
    website_by: "Website von",
  },
  banner: {
    office_open: "Büro Boudry geöffnet · 08:00–19:00 CET",
  },
  neuchatel: {
    eyebrow: "Geboren in der Schweiz",
    title_a: "Entwickelt in",
    title_b: "Neuchâtel",
    title_c: "für den Schweizer Markt.",
    desc: "O'javana wird von Boudry im Kanton Neuenburg betrieben. Unsere Ingenieure, Support-Mitarbeiter und Techniker vor Ort sprechen Deine Sprache, kennen Deinen Markt und antworten, wenn Du anrufst.",
    stat_response: "Antwort",
    stat_response_value: "Innerhalb einer Stunde",
    stat_onsite: "Vor Ort",
    stat_onsite_value: "Innerhalb von 48 h",
    stat_hosted: "Gehostet",
    stat_hosted_value: "Schweizer Rechenzentren",
    cta_talk: "Mit einem lokalen Spezialisten sprechen",
    cta_callback: "Rückruf anfordern",
    hq_label: "/hq · schweiz",
    hq_name: "Boudry",
    geo_line: "50 Minuten von Bern · 90 Minuten von Zürich und Genf.",
    hours_label: "Öffnungszeiten",
    hours_value: "08:00 – 19:00 CET",
    langs_label: "Sprachen",
    langs_value: "FR · DE · EN · IT",
  },
  whypage: {
    counter: "Aus Neuchâtel · 234 Betriebe live",
    eyebrow: "Warum O'javana",
    h1_a: "Einfach zu bedienen,",
    h1_b: "günstiger",
    h1_c: ", effizient &",
    h1_d: "lokaler Support",
    h1_e: ".",
    intro: "Günstigere, nicht-lokale Lösungen sparen Dir ein wenig — und machen Dich müde. Wenn etwas ausfällt, rennst Du ihnen hinterher. Mit O'javana sitzt das Team in der Schweiz, das Telefon wird abgenommen und Dein Betrieb läuft weiter.",
    cta_h2_a: "Besuche unseren Showroom in",
    cta_h2_b: "Boudry",
    cta_h2_c: "noch heute!",
    cta_body: "Komm auf einen Kaffee vorbei und erlebe das Produkt in echtem Einsatz.",
    book_visit: "Besuch buchen",
    see_pricing: "Preise ansehen",
    easy_title: "Einfach zu bedienen",
    easy_body: "Neues Personal in 12 Minuten einweisen — nicht in 12 Tagen. Grosse Kacheln, klare Abläufe, kein Handbuch nötig. Die Art Kasse, die Dein Wochenend-Personal bis zum Mittagessen beherrscht.",
    easy_p1: "Bestellung in unter einer Sekunde",
    easy_p2: "12-Minuten-Einarbeitung für das Team",
    easy_p3: "Grosse Touch-Kacheln, keine verschachtelten Menüs",
    easy_p4: "Gleiche Oberfläche an Kasse, Kiosk und Handheld",
    cheaper_title: "Günstigere Hardware",
    cheaper_body: "Einstieg ab CHF 39/Monat mit unserem Terminal. Berechtigte Händler erhalten das POS-Bundle und sogar den Self-Order-Kiosk ohne Anschaffungskosten.",
    cheaper_p1: "CHF 0 Hardware für berechtigte Händler",
    cheaper_p2: "0,90 % Kartengebühr mit unseren Terminals",
    cheaper_p3: "23,8\" Self-Order-Kiosk für CHF 1'980",
    cheaper_p4: "Keine Feature-Freischaltungen, keine Setup-Gebühren",
    efficient_title: "Effizient",
    efficient_body: "Offline-first POS, Echtzeit-Analysen und eine Küchenübergabe, die nicht vom Cloud-Roundtrip abhängt. Gebaut für den Freitagabend um 20 Uhr.",
    efficient_p1: "Offline-first — kein Verkauf geht verloren",
    efficient_p2: "Echtzeit-Dashboard für mehrere Standorte",
    efficient_p3: "Kitchen Display + Customer Display inklusive",
    efficient_p4: "UberEats, QR & Online — ein Ticket",
    local_title: "Lokaler Support",
    local_body: "Echte Menschen in Neuchâtel — kein Callcenter im Ausland, keine Ticket-Warteschlange, kein Warten von einer Woche. Antwort innerhalb einer Stunde und Hilfe vor Ort innerhalb von 48 Stunden.",
    local_p1: "Betrieben aus Neuchâtel · Schweiz",
    local_p2: "Antwort innerhalb einer Stunde, Fix am selben Tag",
    local_p3: "Hilfe vor Ort innerhalb von 48 Stunden",
    local_p4: "Telefon in FR · DE · EN · IT",
  },
  payments_page: {
    eyebrow: "Zahlungen",
    h1: "Alles akzeptieren. Nichts abgleichen.",
    intro_a: "Durch unsere Zusammenarbeit mit Swisspayout akzeptieren alle O'javana-Terminals, Kiosks und Online-Checkouts Karten, kontaktlos, TWINT und die wichtigsten Mobile Wallets — alles auf einem Konto abgerechnet. Für Details siehe",
  },
  sitemap_page: {
    eyebrow: "Sitemap",
    h1: "Jede Seite auf O'javana.",
    intro: "Ein Bildschirm, alle Routen. Eine nützliche Referenz für Menschen und ein klares Signal für Suchmaschinen.",
    sec_discover: "Entdecken",
    sec_product: "Produkt",
    sec_industries: "Branchen",
    sec_pricing_tools: "Preise & Tools",
    sec_contact: "Kontakt",
    sec_legal: "Rechtliches",
    lbl_home: "Startseite",
    lbl_why: "Warum O'javana",
    lbl_about: "Über uns",
    lbl_industries_all: "Branchen",
    lbl_case_studies: "Referenzen",
    lbl_blog: "Blog",
    lbl_vs_ls: "vs Lightspeed",
    lbl_pos: "Kassensystem",
    lbl_kiosk: "Self-Order-Kiosk",
    lbl_waiter: "Kellner-App",
    lbl_qr: "QR-Bestellung & Bezahlung",
    lbl_shop: "Online-Shop",
    lbl_terminals: "Zahlungsterminals",
    lbl_loyalty: "Geschenkkarten & Treue",
    lbl_all_products: "Alle Produkte",
    lbl_qsr: "Schnellservice",
    lbl_delivery: "Lieferservice",
    lbl_restaurants: "Restaurants & Cafés",
    lbl_grocery: "Lebensmittel & Convenience",
    lbl_foodtruck: "Food Truck",
    lbl_franchise: "Franchise & Multi-Brand",
    lbl_pricing: "Preise",
    lbl_offers: "Angebote",
    lbl_configurator: "Preiskonfigurator",
    lbl_payments: "Zahlungen",
    lbl_contact: "Kontakt",
    lbl_callback: "Rückruf anfordern",
    lbl_book_demo: "Demo buchen",
    lbl_imprint: "Impressum",
    lbl_privacy: "Datenschutz",
    lbl_terms: "AGB",
    lbl_sitemap: "Sitemap",
    sec_cities: "Städte — POS",
    sec_service_areas: "Servicegebiete",
    sec_alternatives: "Alternativen",
    sec_seo_solutions: "Lösungen (SEO)",
    lbl_pos_in: "POS",
    lbl_alt_suffix: "Alternative",
  },
  contact_page: {
    eyebrow: "Kontakt",
    h1: "Sprich mit den Menschen, die es gebaut haben.",
    intro: "Schreib uns — ein Schweizer Spezialist meldet sich innerhalb einer Geschäftsstunde. Oder ruf an — wir nehmen ab.",
    address: "Rue Louis-Favre 12 · 2017 Boudry · Schweiz",
    time_hint: "~1 Minute",
    f_full_name: "Vollständiger Name",
    f_phone: "Telefon",
    f_email: "E-Mail",
    f_message: "Nachricht",
    ph_full_name: "Anna Müller",
    ph_phone: "+41 79 000 00 00",
    ph_email: "du@business.com",
    ph_message: "Erzähl uns von Deinem Betrieb und wie wir helfen können.",
    agree: "Mit dem Absenden stimmst Du unserem Datenschutzhinweis zu.",
    send: "Nachricht senden",
    sending: "Wird gesendet...",
    success_title: "Erhalten.",
    success_body: "Ein Spezialist antwortet innerhalb einer Geschäftsstunde.",
    send_another: "Weitere Nachricht senden",
    toast_success: "Danke. Wir melden uns in Kürze.",
    toast_error: "Senden fehlgeschlagen. Bitte erneut versuchen.",
  },
  pricing_page: {
    eyebrow: "Preise",
    h1_a: "Eine Plattform.",
    h1_b: "Unschlagbare Preise.",
    intro_a: "Keine Setup-Gebühren. Keine Feature-Freischaltungen. Kartengebühr bei",
    intro_b_with: "mit O'javana-Zahlungsterminals",
    intro_b_without: "bei Starter ohne unser Terminal",
    banner_eligible: "Berechtigte Händler",
    banner_h2_a: "Gratis Hardware, wenn Dein Kartenumsatz über",
    banner_h2_amount: "CHF 20'000/Monat",
    banner_h2_z: " liegt.",
    banner_body: "Verarbeite mehr als CHF 20'000 pro Monat in Kartenzahlungen und wir liefern Dein POS-Terminal, Zahlungsgerät, Drucker und Kassenschublade ohne Anschaffungskosten. Im Freedom-Plan ist der 23,8\" Self-Order-Kiosk in derselben Berechtigung inbegriffen — kombiniert mit unserem",
    banner_rate_phrase: "Spezialtarif von 0,90 % für Kartenzahlungen",
    banner_pt1: "12-Monats-Verpflichtung, Fair-Use-Ersatz inklusive",
    banner_pt2: "Berechtigung monatlich geprüft — keine versteckten Gebühren",
    banner_pt3: "Schweiz, EU und Adyen-unterstützte Märkte",
    banner_check: "Berechtigung prüfen",
    banner_callback: "Rückruf anfordern",
    banner_bundle_caption: "Standard-Bundle: Dual-Screen-POS, Kassenschublade, 80-mm-Drucker, EMV/NFC/TWINT-Terminal.",
    hw_sw_label: "Hardware + Software",
    toggle_terminal: "Mit O'javana-Zahlungsterminal",
    toggle_terminal_caption: "−30 CHF / Monat · 0,90 % Kartentarif",
    toggle_yearly: "Jährliche Abrechnung",
    toggle_yearly_caption: "2 Monate gratis · zahle 10× monatlich",
    most_chosen: "Am häufigsten gewählt",
    per_yr: "/Jahr",
    per_mo: "/Monat",
    per_station: "· pro Station",
    with_term_save: "−CHF 30 mit unserem Terminal",
    two_months_free: "2 Monate gratis vs. monatlich",
    premium_kiosk_led: "Premium · Kiosk-fokussiert",
    freedom_meta: "/freedom · Abo",
    freedom_kiosk_note: "Kiosk-Hardware (23,8\") gratis für berechtigte Händler mit CHF 20K+ monatlichem Kartenumsatz mit O'javana-Terminals.",
    freedom_cta: "Freedom wählen",
    freedom_fixed: "Fester Bundle-Preis · ändert sich nicht mit dem Terminal",
    plan_includes: "Alle Pläne beinhalten unbegrenzte Bestellungen, PCI- & DSGVO-Konformität, Schweizer Hosting, 30-Tage-Geld-zurück-Garantie und nahtlose Updates. Self-Order-Kiosk 23,8\" Hardware:",
    plan_includes_unit: "pro Einheit (oder gratis mit Freedom bei Berechtigung).",
    kds_cds_footnote: "* Kitchen Display System (KDS) 15,6\" und Customer Display System (CDS) 10\" sind als optionale Add-ons in allen Plänen verfügbar, auch Complete — CHF 480 (KDS) und CHF 220 (CDS) pro Einheit.",
    addon_label: "Zusätzliche Hardware",
    addon_h2_a: "Self-Order-Kiosk 23,8\" ·",
    addon_body: "Theken- oder Stand-Kiosk mit TWINT-fähiger Zahlung, Bondrucker und Barcode-Scanner. Gratis im Freedom-Abo bei monatlicher Kartenumsatz-Berechtigung.",
    addon_p1: "23,8\" Multi-Touch-Screen, entspiegelt",
    addon_p2: "Integriertes EMV/NFC/TWINT-Terminal",
    addon_p3: "Integrierter 80-mm-Bondrucker",
    addon_p4: "Integrierter 1D/2D-Barcode-Scanner",
    addon_p5: "Kitchen Display System (KDS) 15,6\" · CHF 480",
    addon_cta_cfg: "Hardware-Bundle konfigurieren",
    addon_cta_kiosk: "Kiosk entdecken",
    starter_name: "Starter",
    starter_blurb: "Echtes Cloud-POS diese Woche live. Karten akzeptieren, Schichten führen, sauber abschliessen.",
    starter_cta: "Mit Starter starten",
    grow_name: "Grow",
    grow_blurb: "Kellner-App und Bestellung am Tisch hinzufügen. Das Setup, das die meisten Cafés brauchen.",
    grow_cta: "Grow wählen",
    complete_name: "Complete",
    complete_blurb: "Multi-Station, Multi-Standort, alle Kanäle — das volle Operations-Cockpit.",
    complete_cta: "Complete holen",
    freedom_name: "Freedom",
    freedom_blurb: "Kiosk-fokussierte Betriebe. Gleiches Complete-Bundle plus der 23,8\" Self-Order-Kiosk — inklusive.",
  },
  configurator_page: {
    hardware_label: "Hardware",
    important: "Wichtig",
    tier_intro: "Dein monatlicher Kartenumsatz",
    with_term_label: "Mit O'javana-Zahlungsterminal",
    with_term_caption: "Lizenzgebühr −CHF 39 / Monat pro Station",
    note_tier_rental: "Der Kunde muss die genannten Umsätze 6 Monate in Folge halten, um den reduzierten Preis (oder gratis Material) zu behalten. Der bezahlte Materialpreis wird in Form von erlassenen Software-Lizenzgebühren über eine gleichwertige Anzahl Monate oder als Gutschein zurückerstattet.",
    note_rate: "Optionale monatliche Versicherung + SIM-Karten-Gebühren für Zahlungsterminals: CHF 29 / Monat für S1F2 und CHF 19 / Monat für AMS1, jährlich abgerechnet.",
    note_install: "Menüprogrammierung & Installation vor Ort: einmalige Gebühr von CHF 380.",
    book_demo_link: "Oder Live-Demo buchen →",
    free_label: "GRATIS",
    free_eligible: "gratis bei berechtigtem Umsatz",
    stations_label: "Stationen",
    per_station_save: "−CHF 30 / Station mit Terminal",
    bundle_label: "POS-Bundle hinzufügen",
    bundle_reset: "Bundle zurücksetzen",
    bundle_caption: "POS · AMS1-Terminal · Bondrucker · Kassenschublade",
    bundle_only: "Nur gratis im POS-Bundle",
    pos_bundle_table: "POS-Bundle",
    pos_bundle_table_caption: "Gratis bei 100 %-Stufe · reduziert bei anderen Stufen",
    optional_hw_table: "Optionale Hardware",
    optional_hw_table_caption: "Reduziert bei 30 / 40 / 50 %-Stufen · Vollpreis bei 100 %-Stufe",
    tier_t0: "Unter CHF 5'000",
    tier_t1: "CHF 5'000 – 10'000",
    tier_t2: "CHF 10'000 – 15'000",
    tier_t3: "CHF 15'000 – 20'000",
    tier_t4: "CHF 20'000+",
    mobile_quote: "Angebot",
    mobile_view_full: "Tippen für vollständiges Angebot",
  },
  offers: {
    nav: "Angebote",
    eyebrow: "Zeitlich begrenzte Aktionen",
    h1: "Angebote, für die sich der Wechsel lohnt.",
    intro: "Handverlesene O'javana-Angebote — Neukunden-Rabatte, gratis Hardware, Saisonpakete. Sichere sie, bevor sie ablaufen.",
    empty_title: "Aktuell keine laufenden Angebote.",
    empty_body: "Schau bald wieder vorbei — oder buche eine Demo und wir stellen Dir eines zusammen.",
    free: "Gratis",
    view: "Angebot ansehen",
    days_left: "Noch {n} Tage",
    all_offers: "Alle Angebote",
    details: "Über dieses Angebot",
    terms: "Allgemeine Geschäftsbedingungen",
    valid_until: "Gültig bis {date}",
    other_offers: "Weitere laufende Angebote",
    not_found: "Dieses Angebot existiert nicht.",
    expired_banner: "Dieses Angebot ist nicht mehr verfügbar. Schau Dir unsere anderen Angebote an.",
    check_others: "Laufende Angebote ansehen",
    claim_this_offer: "Angebot anfordern",
    full_name: "Dein vollständiger Name",
    email: "Deine E-Mail",
    phone: "Telefonnummer",
    business_name: "Betriebsname (optional)",
    have_code: "Hast Du einen Code?",
    voucher_ph: "Gutscheincode eingeben (optional)",
    submit: "Anfrage senden",
    sending: "Wird gesendet...",
    privacy_hint: "Wir nutzen Deine Daten nur zur Bearbeitung dieses Angebots. Nie verkauft oder gespammt.",
    success_title: "Danke — Anfrage erhalten.",
    success_body: "Wir melden uns innerhalb eines Geschäftstages mit den nächsten Schritten.",
    popup_cta: "Angebot sichern →",
    cta_headline: "Um dieses Angebot zu sichern, fülle das Formular unten aus.",
    cta_sub: "Wir bestätigen innerhalb eines Geschäftstages. Oder bezahle direkt unter dem Formular.",
    or: "oder",
    buy_now_title: "Lieber dieses Angebot sofort kaufen?",
    buy_now_sub: "Bezahle in Sekunden per Karte oder Apple Pay. Deine Daten sind durch Adyen geschützt.",
    you_pay: "Du zahlst",
    pay_now: "Jetzt kaufen",
    buy_direct_headline: "Dieses Angebot sofort kaufen.",
    buy_direct_sub: "Gib Deine Daten unten ein, bezahle per Karte oder TWINT, und wir aktivieren Dein Angebot.",
    your_details: "Deine Angaben",
    ask_pill: "Hast Du eine Frage?",
    ask_headline: "Noch nicht bereit zu kaufen? Fülle das Formular unten aus — wir melden uns bei Dir.",
    ask_sub: "Schick uns Deine Fragen oder spezifischen Anforderungen — Antwort innerhalb eines Geschäftstages.",
    claim_headline_no_pay: "Um dieses Angebot zu sichern, fülle das Formular unten aus.",
    claim_sub_no_pay: "Wir bestätigen innerhalb eines Geschäftstages mit den nächsten Schritten.",
    fill_contact_first: "Bitte fülle zuerst Name, E-Mail und Telefon aus.",
    voucher_invalid: "Gutschein nicht erkannt — Du kannst trotzdem ohne Code absenden.",
  },
  solutions_page: {
    eyebrow_all: "Alle Lösungen",
    h1_a: "Stell den Stack zusammen, der zu",
    h1_b: "Deinem Betrieb passt.",
    intro: "Jedes Modul einzeln oder als Teil der All-in-One-Suite. Kombiniere, was Du brauchst.",
    back: "← Zurück zu Lösungen",
    book_demo: "Demo buchen",
    configure_hardware: "Hardware konfigurieren",
    what_you_get: "Was Du bekommst",
    pairs_with: "Passt gut zu",
  },
  compare_page: {
    pill: "Schweizer Vergleich",
    h1_a: "O'javana vs",
    h1_ls: "Lightspeed",
    h1_b: "Die lokale, fokussierte Wahl.",
    intro: "Lightspeed ist eine solide globale Suite. Aber wenn Du ein Schweizer Restaurant oder Geschäft führst, brauchst Du keine 200 Funktionen und eine Ticket-Warteschlange — Du brauchst eine Kasse, die einfach funktioniert, mit einem Team, das abnimmt.",
    side_by_side: "Direktvergleich",
    full_picture: "Das volle Bild.",
    vp_honest_title: "Ehrliche Preise",
    vp_honest_body: "Starter ab CHF 39/Monat mit unserem Terminal. Keine Setup-Gebühren, keine Feature-Freischaltungen, keine Überraschungs-Add-ons. Kartengebühr 0,90 % mit O'javana-Terminals.",
    vp_focused_title: "Fokussiertes Produkt",
    vp_focused_body: "POS, Kiosks, Online, Zahlungen, Geschenkkarten & Treue, Inventar — das war's. Kein 200-Funktionen-Menü, das Du nie nutzt.",
    vp_local_title: "Lokaler Schweizer Support",
    vp_local_body: "Antwort innerhalb einer Stunde. Fix am selben Tag. Vor Ort innerhalb von 48 Stunden. Von einem echten Team in Neuchâtel — nicht einer globalen Ticket-Warteschlange.",
    vp_hw_title: "Hardware gratis für berechtigte Händler",
    vp_hw_body: "Über CHF 20'000 Kartenumsatz pro Monat? Dein POS-Bundle, Zahlungsterminal und sogar der Self-Order-Kiosk werden ohne Anschaffungskosten geliefert.",
    dim: "Dimension",
    footnote: "Vergleich basiert auf öffentlich verfügbaren Lightspeed Retail / Restaurant Preisen und Hardware-Bundle-Seiten zum Zeitpunkt der Erstellung. Dein tatsächliches Angebot kann abweichen.",
    bottom_h2: "Willst Du von Lightspeed wechseln?",
    bottom_body: "Wir migrieren Dein Menü, Deine Produkte und Berichte gratis. Installation innerhalb von 48 Stunden, Terminals am selben Tag versendet für berechtigte Händler.",
    bottom_cta: "Wechsel-Beratung buchen",
    bottom_cta2: "Unsere Preise ansehen",
  },
  eligibility: {
    eyebrow: "30-Sekunden-Berechtigungscheck",
    title: "Finde Deine Stufe in 30 Sekunden.",
    subtitle: "Vier kurze Fragen — wir schlagen Dir den Plan, Terminal-Rabatt, Hardware-Bundle-Berechtigung und Deine erwartete Rechnung im ersten Monat vor.",
    q1: "Wie hoch ist Dein monatlicher Kartenumsatz?",
    q1_t0: "Unter CHF 5'000",
    q1_t1: "CHF 5'000 – 10'000",
    q1_t2: "CHF 10'000 – 15'000",
    q1_t3: "CHF 15'000 – 20'000",
    q1_t4: "CHF 20'000+",
    q2: "Wie viele POS-Stationen?",
    q3: "Wo befindet sich Dein Betrieb?",
    q3_ch: "Schweiz",
    q3_eu: "EU (Adyen-unterstützt)",
    q3_other: "Andere",
    q4: "Nutzt Du heute schon ein POS?",
    q4_yes: "Ja, ich wechsle",
    q4_no: "Nein, Neueröffnung",
    result_eyebrow: "Empfohlenes Setup",
    result_plan: "Plan",
    result_terminal: "Mit O'javana-Zahlungsterminal",
    result_bundle: "POS-Bundle-Hardware",
    result_invoice: "Erwartete Rechnung im ersten Monat",
    bundle_free: "Gratis für berechtigte Händler",
    bundle_paid: "CHF 1'065 einmalig",
    bundle_freedom: "Gratis Kiosk + POS-Bundle",
    ineligible: "Wir unterstützen aktuell die Schweiz und Adyen-unterstützte EU-Märkte. Melde Dich trotzdem — wir finden einen Partner für Dich.",
    cta: "Demo mit diesem Setup buchen",
    restart: "Neu starten",
    tier_starter: "Starter",
    tier_grow: "Grow",
    tier_complete: "Complete",
    tier_freedom: "Freedom",
    step: "Schritt",
    of: "von",
    next: "Weiter",
    back: "Zurück",
    one_time_install: "+ einmalig CHF 380 Menüprogrammierung & Installation",
  },
  compare_cta: {
    eyebrow: "vs Lightspeed",
    h2_a: "Gleiche Aufgabe.",
    h2_b: "Weniger Ballast.",
    h2_c: "Halbe Rechnung.",
    body: "O'javana ist die fokussierte, in der Schweiz gebaute Alternative zu aufgeblähten globalen POS-Suiten. Kein Upsell-Wasserfall, keine Ticket-Warteschlangen, keine Überraschungs-Hardware-Rechnungen.",
    cta: "Vollständigen Vergleich lesen",
    cta2: "30-Min-Demo buchen",
    dim: "Dimension",
  },
  industries_page: {
    eyebrow: "Branchen",
    h1_a: "Eine Plattform.",
    h1_b: "Sechs Branchen.",
    intro: "Von kiosk-fokussiertem QSR bis Multi-Brand-Franchise — gleicher O'javana-Stack, anderer Playbook.",
    book_demo_for: "Demo buchen für",
  },
  industries_section: {
    restaurants_title: "Restaurants & Cafés",
    restaurants_body: "Gastraum. Küche. Online. Alles auf einem Ticket.",
    retail_title: "Einzelhandel & Boutiquen",
    retail_body: "Schneller Checkout, Inventar das immer stimmt, Zahlungen integriert.",
  },
  kiosk_section: {
    p1: "21\" & 27\" Hardware, montagefertig",
    p2: "Intelligente Upsell-Engine, pro Menü trainiert",
    p3: "Apple Pay · Google Pay · EMV-Chip",
    p4: "Direkte Ticket-Weiterleitung in die Küche",
  },
  payments_section: {
    eyebrow: "Zahlungsmethoden",
    h2: "Jede Zahlung akzeptieren. Ohne Politik.",
    body_a: "Wir verarbeiten Zahlungen in Zusammenarbeit mit",
    body_b: ". Ein Vertrag. Ein Gerät. Karten, kontaktlos, TWINT und Wallets — direkt an die Kasse angebunden.",
    coverage: "Abdeckung",
    coverage_title: "Funktioniert überall, wo Adyen Zahlungen akzeptiert.",
    coverage_body: "Von Zürich über Madrid bis Helsinki — ganz Europa in einem Acquiring-Vertrag.",
    compliance: "Compliance",
    compliance_title: "PCI DSS · 3-D Secure 2 · DSGVO.",
    compliance_body: "Compliance ist mitgeliefert, nicht konfiguriert. Betrugserkennung inklusive.",
    ch_first: "Schweiz-first",
    ch_first_title: "TWINT, fest eingebaut.",
    ch_first_body: "Natives TWINT an jedem Kiosk, Terminal und Online-Checkout.",
  },
  demo_interests: {
    pos: "POS",
    kiosk: "Kiosk",
    online_shop: "Online-Shop",
    qr_order: "QR-Bestellung & Bezahlung",
    waiter_app: "Kellner-App",
    payment: "Zahlung",
  },
  common: {
    close: "Schliessen",
    error_submit: "Senden fehlgeschlagen. Bitte erneut versuchen.",
  },
  seo: {
    service_area: "Servicegebiet",
    book_demo_in: "Demo buchen in",
    book_demo: "Demo buchen",
    request_callback: "Rückruf anfordern",
    configure_hardware: "Hardware konfigurieren",
    faq_title: "FAQ",
    faq_q1: "Unterstützt O'javana TWINT?",
    faq_a1: "Ja — TWINT ist nativ an jedem O'javana-Terminal, Kiosk und Online-Checkout. Kein Plugin, kein Extra-Konto.",
    faq_q2: "Wie schnell ist die Installation vor Ort?",
    faq_a2: "Innerhalb von 48 Stunden in den meisten Schweizer Kantonen. Am selben Tag im Kanton Neuenburg, wo unser Hauptsitz ist.",
    faq_q3: "Wie hoch ist die Kartengebühr?",
    faq_a3: "0,90 % für alle Kartenzahlungen, wenn Du O'javana mit unseren über Swisspayout akquirierten Terminals kombinierst.",
    other_cities: "Weitere Städte, die wir bedienen",
    signal_response: "Antwort",
    signal_response_value: "Innerhalb einer Stunde",
    signal_onsite: "Vor Ort",
    signal_onsite_value: "Innerhalb von 48 h",
    signal_hosted: "Gehostet",
    signal_hosted_value: "Schweizer Rechenzentren",
    ours_label: "O'javana — was Du bekommst",
    them_label_suffix: "— was fehlt",
    switch_from: "Wechseln von",
    see_pricing: "Unsere Preise ansehen",
    alt_faq_q1: "Kann ich gratis von {competitor} migrieren?",
    alt_faq_a1: "Ja — unser Team migriert Dein Menü, Deine Produkte, Kunden und Berichte von {competitor} kostenlos. Die meisten Betriebe wechseln innerhalb von 48 Stunden.",
    alt_faq_q2: "Behalte ich TWINT und kontaktlos?",
    alt_faq_a2: "Natives TWINT, Apple Pay, Google Pay, EMV-Chip und Tap-to-Pay auf iPhone & Android — alles inklusive.",
    alt_faq_q3: "Was kostet es monatlich?",
    alt_faq_a3: "Starter ab CHF 39/Monat mit unserem Terminal. Keine Setup-Gebühren, keine Feature-Freischaltungen.",
  },
};
